import React from 'react';
import CuadroListaEditable from '../edicion/CuadroListaEditable.js';
import * as Data from '../edicion/data/DataClubLinks.js';
import * as DTOs from '../edicion/DTOs/LinksClubDTOs.js';
import * as Funciones from '../edicion/funciones/FuncionesLinks.js';

const LinksClub = (props) => {
  const idClub = props.club && props.club.id;

  return (
    <CuadroListaEditable
      titulo="Links"
      idPadre={idClub}
      data={Data}
      dtos={DTOs}
      funciones={Funciones}
    />
  );
};

export default LinksClub;
